import React from 'react';
import CityComponent from '../Component/CityComponent';

export default function CityContainer() {
  return <CityComponent />;
}
